import router from "../index";

export default [
  {
    path: "/PhysicalTestList",
    component: () => import('../../views/PhysicalTest/PhysicalTestList/PhysicalTestList'),
    beforeEnter: (to, from, next) => {
      if (router.app.$cookies.get("user") === "admin")
        next();
      else
        router.replace("/home");
    },
    meta: {
      title: '体测成绩列表'
    }
  },
]
